import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import Save16 from '@carbon/icons-react/es/save/16';
import { Button } from '@rocketlane/ui';
import React, { useEffect, useMemo, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { Radio } from 'components/atoms/radio';
import { Input } from 'components/facade/input';
import { SettingsControlPanel } from 'components/molecules/settings/control-panel';
import { useTranslate } from 'hooks/use-translation';
import { useUpdateSettings } from '../use-feature-setting';
const StyledSmallText = styled.div`
  font-size: var(--font-size-sm);
  color: var(--gray-70);
`;
export const StyledRadioGroup = styled(Radio.Group)`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-03);
`;
export const StyledCustomInputWrapper = styled.div`
  display: flex;
  gap: var(--spacing-03);
`;
const CUSTOM_KEY = 'custom';
export const CreditNoteTitle = ({ creditNoteTitle: defaultCreditNoteTitle })=>{
    const translate = useTranslate();
    const [update, isLoading] = useUpdateSettings();
    const [selectedKey, setSelectedKey] = useState();
    const [customCreditNoteTitle, setCustomCreditNoteTitle] = useState('');
    const creditNoteTitleMap = useMemo(()=>({
            credit_note: translate('settings.credit_notes.credit_note_title.option1'),
            credit_memo: translate('settings.credit_notes.credit_note_title.option2'),
            [CUSTOM_KEY]: translate('settings.credit_notes.credit_note_title.option3')
        }), [
        translate
    ]);
    const onSave = (title)=>{
        update({
            payload: {
                creditNoteDisplayTitle: title
            },
            onError: ()=>{
                const entry = Object.entries(creditNoteTitleMap).find(([key, value])=>key !== CUSTOM_KEY && value === defaultCreditNoteTitle);
                if (entry) {
                    setSelectedKey(entry[0]);
                } else {
                    setSelectedKey(CUSTOM_KEY);
                    setCustomCreditNoteTitle(defaultCreditNoteTitle !== null && defaultCreditNoteTitle !== void 0 ? defaultCreditNoteTitle : '');
                }
            }
        });
    };
    useEffect(()=>{
        const entry = Object.entries(creditNoteTitleMap).find(([key, value])=>key !== CUSTOM_KEY && value === defaultCreditNoteTitle);
        if (entry) {
            setSelectedKey(entry[0]);
        } else {
            setCustomCreditNoteTitle(defaultCreditNoteTitle !== null && defaultCreditNoteTitle !== void 0 ? defaultCreditNoteTitle : '');
            setSelectedKey(CUSTOM_KEY);
        }
    }, [
        creditNoteTitleMap,
        defaultCreditNoteTitle
    ]);
    return /*#__PURE__*/ _jsx(SettingsControlPanel, {
        label: translate('settings.credit_notes.credit_note_title'),
        descriptions: [
            translate('settings.credit_notes.credit_note_title.description')
        ],
        children: /*#__PURE__*/ _jsxs(StyledRadioGroup, {
            value: selectedKey,
            onChange: (e)=>{
                const key = e.target.value;
                setSelectedKey(key);
                if (key !== CUSTOM_KEY) {
                    onSave(creditNoteTitleMap[key]);
                }
            },
            children: [
                Object.entries(creditNoteTitleMap).map(([key, label])=>/*#__PURE__*/ _jsx(Radio, {
                        value: key,
                        children: label
                    }, key)),
                selectedKey === CUSTOM_KEY && /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsxs(StyledCustomInputWrapper, {
                            children: [
                                /*#__PURE__*/ _jsx(Input, {
                                    value: customCreditNoteTitle,
                                    placeholder: translate('settings.credit_notes.credit_note_title.custom.placeholder'),
                                    onChange: (e)=>setCustomCreditNoteTitle(e.target.value),
                                    maxLength: 32
                                }),
                                /*#__PURE__*/ _jsx(Button, {
                                    disabled: customCreditNoteTitle.length === 0,
                                    onClick: ()=>onSave(customCreditNoteTitle),
                                    variant: "primary",
                                    type: "button",
                                    leftIcon: /*#__PURE__*/ _jsx(Save16, {}),
                                    loading: isLoading,
                                    children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                        id: "save"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx(StyledSmallText, {
                            children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                id: "settings.credit_notes.credit_note_title.custom.max_length"
                            })
                        })
                    ]
                })
            ]
        })
    });
};
